"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.setAddress = exports.getUserData = exports.userSlice = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _agent = require("@deosite/agent");
var _mapAddressesCollection = _interopRequireDefault(require("@deosite/helpers/mapAddressesCollection"));
var initialState = {
  firstName: "",
  lastName: "",
  email: "",
  addresses: [],
  orders: [],
  loading: false,
  ePoints: 0,
  checkoutAddress: null
};
var getUserData = (0, _toolkit.createAsyncThunk)("user/getUserData", function (arg) {
  var token = arg.token,
    language = arg.language;
  return _agent.requests.get(global.__appConfig__.customerDataUrl, false, token, language);
});
exports.getUserData = getUserData;
var userSlice = (0, _toolkit.createSlice)({
  name: "user",
  initialState: initialState,
  reducers: {
    setAddress: function setAddress(state, action) {
      state.checkoutAddress = action.payload;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(getUserData.pending, function (state) {
      state.loading = true;
    });
    builder.addCase(getUserData.fulfilled, function (state, action) {
      state.loading = false;
      state.email = action.payload.email;
      state.addresses = (0, _mapAddressesCollection["default"])(action.payload);
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.ePoints = action.payload.extension_attributes.rewardpoints_balance;
    });
  }
});
exports.userSlice = userSlice;
var setAddress = userSlice.actions.setAddress;
exports.setAddress = setAddress;
var _default = userSlice.reducer;
exports["default"] = _default;